import { GridWidgetsProvider } from './GridWidgetsProvider';
import DraggableHandler from './components/DraggableHandler';
import GridBoard from './components/GridBoard';
import Placeholder from './components/Placeholder';
import Widgets from './components/Widgets';

const GridWidgets = ({ children, state, spacing, onChange }) => (
  <GridWidgetsProvider state={state} spacing={spacing} onChange={onChange}>
    <GridBoard>
      <Widgets>{children}</Widgets>
      <Placeholder />
    </GridBoard>
  </GridWidgetsProvider>
);

GridWidgets.DraggableHandler = DraggableHandler;

export default GridWidgets;
